import styled from 'styled-components';

export const Iframe = styled.iframe`
  position: fixed;
  height: 100%;
  width: 100%;
  border: none;
`;
